import { render } from "./MovesPage.vue?vue&type=template&id=0cbe627c&scoped=true"
import script from "./MovesPage.vue?vue&type=script&lang=js"
export * from "./MovesPage.vue?vue&type=script&lang=js"

import "./MovesPage.vue?vue&type=style&index=0&id=0cbe627c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbe627c"]])

export default __exports__